import React, { useState } from "react";
import Table from "../../../common/element/Table";
import Button from "../../../common/element/Buttons";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../common/Common/DeleteModal";
import ThreeDotBouncingLoader from "../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import {
  clearDeleteEmployee,
  deleteEmployee,
} from "../../../redux/Employee/employeesSlice";
import SweetAlertService from "../../../common/SweetAlert/SweetAlert";
import { useDispatch } from "react-redux";
import moment from "moment";
import CommonIconButton from "../../../common/icons/CommonIconButton";
import ConvertBatchModal from "./ConvertBatchModal";


const { Tr, Th, Td, THead, TBody } = Table;

const EmployeeList = ({
  employeesListData,
  onEdit,
  employeesLoading,
  fetchEmployees,
  // ADD THESE TWO PROPS
  currentPage = 1,
  itemsPerPage = 10
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [employeeToDelete, setEmployeeToDelete] = useState(null);

  // Convert Batch Modal state
  const [convertModalOpen, setConvertModalOpen] = useState(false);
  const [convertEmployee, setConvertEmployee] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEdit = (item) => {
    onEdit(item);
  };

  const handleDelete = async () => {
    if (!employeeToDelete) return;

    const employeeId =
      employeeToDelete?.company_employee_id ||
      employeeToDelete?.employee_id ||
      employeeToDelete?.id ||
      employeeToDelete?._id;

    try {
      await dispatch(
        deleteEmployee({
          employee_id: Number(employeeId),
        })
      ).unwrap();

      SweetAlertService.showSuccess({
        title: "Deleted",
        message: "Employee deleted successfully",
      });

      setIsOpen(false);
      setEmployeeToDelete(null);
      dispatch(clearDeleteEmployee());
      fetchEmployees();
    } catch (error) {
      SweetAlertService.showError({
        title: "Error",
        message: error || "Failed to delete employee",
      });
      setIsOpen(false);
    }
  };

  return (
    <div className="border rounded-lg border-gray-200">
      <Table>
        <THead>
          <Tr>
            <Th>S No.</Th>
            <Th>Employee Name</Th>
            <Th>Email Address</Th>
            <Th>Mobile Number</Th>
            <Th>Batch</Th>
            <Th>Last Session Date</Th>
            <Th>Action</Th>
          </Tr>
        </THead>

        <TBody>
          {employeesLoading ? (
            <Tr>
              <Td colSpan={7} className="text-center py-6">
                <ThreeDotBouncingLoader />
              </Td>
            </Tr>
          ) : employeesListData?.length > 0 ? (
            employeesListData.map((item, index) => {

              // --- LOGIC CHANGE HERE ---
              // Calculate global serial number
              const serialNumber = (currentPage - 1) * itemsPerPage + index + 1;

              return (
                <Tr key={item?.id || index}>
                  {/* Display the calculated serial number */}
                  <Td>{String(serialNumber).padStart(2, "0")}</Td>

                  <Td>
                    {item.user?.first_name} {item.user?.last_name}
                  </Td>
                  <Td>{item.user?.email}</Td>
                  <Td>{item.user?.mobile_number}</Td>
                  <Td>{item.batch?.batch_name || "-"}</Td>
                  <Td>
                    {item.lastSessionDate || item.last_session_date
                      ? moment(item.lastSessionDate || item.last_session_date).format("LL")
                      : "—"}
                  </Td>

                  <Td>
                    <div className="flex gap-1">
                      {/* View */}
                      <CommonIconButton
                      type="view"
                        onClick={() =>
                          navigate(`/employee/view?empId=${item.company_employee_id}`)
                        }
                     />
                       

                      {/* Edit */}
                      <CommonIconButton
                      type="edit"
                        onClick={() => handleEdit(item)}
                      />
                        

                      {/* Delete */}
                      <CommonIconButton
                        type="delete"
                        onClick={() => {
                          setEmployeeToDelete(item);
                          setIsOpen(true);
                        }}
                      />
                        
                      {/* Convert company */}
                      <CommonIconButton
                        type="convert"
                        label ="Convert Batch"
                        onClick={() => {
                          setConvertEmployee(item);
                          setConvertModalOpen(true);
                        }}
                      />
                        
                    </div>
                  </Td>
                </Tr>
              );
            })
          ) : (
            <Tr>
              <Td colSpan={7} className="text-center py-6 text-gray-500">
                No matching records found
              </Td>
            </Tr>
          )}
        </TBody>
      </Table>

      <DeleteModal
        dialogOpen={isOpen}
        onConfirm={handleDelete}
        onDialogClose={() => setIsOpen(false)}
      />

      {/* Convert Batch Modal */}
      <ConvertBatchModal
        dialogOpen={convertModalOpen}
        onDialogClose={() => setConvertModalOpen(false)}
        employee={convertEmployee}
        onSuccess={fetchEmployees}
      />
    </div>
  );
};

export default EmployeeList;